import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import moment from "moment"
import ReactDatePicker from "react-datepicker"

import {H3} from "@irati/ui/src/Typography/Heading"
import {Hr} from "@irati/ui/src/Layout"
import Button from "@irati/ui/src/Button"
import padding from "@irati/ui/src/global/padding"
import {minWidthMedia} from "@irati/ui/src/global/media"
import id from "@irati/utils/id"
import {FormattedMessage} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"

const BodyContainer = styled.div`
  display: flex;
  align-items: center;

  flex-direction: column;
  justify-content: center;
  ${minWidthMedia.tablet`
    flex-direction: row;
    justify-content: space-around;
    align-items: flex-start;
  `}
`

const DatePickerContainer = styled.div`
  margin-bottom: ${padding.base};

  .react-datepicker {
    font-size: 13px;
    .react-datepicker__current-month {
      font-size: 13px;
    }
    .react-datepicker__day, .react-datepicker__day-name {
      margin: 5px;
    }
  }
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

const END_OF_WEEK = "End of week"
const END_OF_MONTH = "End of month"
const END_OF_QUARTER = "End of quarter"

export default class DatePicker extends Component {
  static propTypes = {
    poll: PropTypes.object.isRequired,
    property: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    minDate: PropTypes.object.isRequired,
    maxDate: PropTypes.object.isRequired,
    endTime: PropTypes.object.isRequired
  }

  static defaultProps = {
    id: "selectEndDate",
    property: "endsAt",
    minDate: moment(),
    maxDate: moment().add(3, "months"),
    endTime: moment().hours(17).minute(0).second(0)
  }

  handleChange = (value) => {
    const {onChange, poll, property, endTime} = this.props
    const date = moment(value)
      .hour(endTime.hour())
      .minute(endTime.minute())
      .second(endTime.second())

    onChange(poll, property, date)
  }

  handlePreset = (type) => {
    switch (type) {
      case END_OF_WEEK:
        return this.handleChange(moment().day("friday"))
      case END_OF_MONTH:
        return this.handleChange(moment().endOf("month"))
      case END_OF_QUARTER:
        return this.handleChange(moment().endOf("quarter"))
      default:
        throw new Error("Unknown type")
    }
  }

  excludeToday = () => {
    const {endTime} = this.props
    const now = moment()
    const excludes = []
    if (endTime < now) {
      excludes.push(now)
    }

    return excludes
  }

  render() {
    const {poll, property, maxDate, minDate, onSubmit} = this.props
    const selectedDate = poll[property] ? moment(poll[property]).toDate() : null

    return (
      <div>
        <H3><FormattedMessage id="recognition.popup.shared.datePicker.title" /></H3>
        <Hr />
        <BodyContainer>
          <DatePickerContainer>
            <ReactDatePicker
              inline
              maxDate={maxDate}
              minDate={minDate}
              excludeDates={this.excludeToday()}
              selected={selectedDate}
              onChange={this.handleChange} />
          </DatePickerContainer>
          <Flex direction="column" alignItems="center">
            <Button full onClick={() => this.handlePreset(END_OF_WEEK)} marginBottom>
              <FormattedMessage id="recognition.popup.shared.datePicker.endOfWeek" />
            </Button>
            <Button full onClick={() => this.handlePreset(END_OF_MONTH)} marginBottom>
              <FormattedMessage id="recognition.popup.shared.datePicker.endOfMonth" />
            </Button>
            <Button full onClick={() => this.handlePreset(END_OF_QUARTER)}>
              <FormattedMessage id="recognition.popup.shared.datePicker.endOfQuarter" />
            </Button>
          </Flex>
        </BodyContainer>
        <ButtonContainer>
          <Button
            id={id("save", this.props)}
            full
            primary
            onClick={onSubmit}>
            <FormattedMessage id="recognition.global.save" />
          </Button>
        </ButtonContainer>
      </div>
    )
  }
}
